import { useState } from 'react';
import { useEventListQuery } from '../../../hooks/queries/event/useEventList';
import { EventsFindResponseBodyDto } from '../../../types/api/events';
import { ALIMTALK_PICKER_PAGE_SIZE } from './constants';
import { PickerModal } from './PickerModal';

type EventItem = EventsFindResponseBodyDto['events'][number];

export type PickedEvent = {
  eventId: number;
  name: string;
};

export type EventPickerModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (event: PickedEvent) => void;
};

export const EventPickerModal = (props: EventPickerModalProps) => {
  const { open, onClose, onConfirm } = props;
  const [search, setSearch] = useState('');

  const { data } = useEventListQuery<EventsFindResponseBodyDto>({
    payload: { page: 0, pageSize: ALIMTALK_PICKER_PAGE_SIZE, mainTitle: search || null },
    options: { enabled: open },
  });
  const eventList: EventItem[] = data?.events ?? [];

  return (
    <PickerModal<EventItem>
      open={open}
      title="기획전 선택"
      searchPlaceholder="기획전명 검색"
      emptyText="기획전이 없습니다."
      mode="single"
      items={eventList}
      getId={(item) => item.id}
      getLabel={(item) => item.mainTitle}
      onSearch={setSearch}
      onClose={onClose}
      onConfirm={(items) => {
        const event = items[0];
        if (event) {
          onConfirm({ eventId: event.id, name: event.mainTitle });
        }
      }}
    />
  );
};
